const SAFETY = {
    LANDING_PAGE: {
        RESOURCE_ID: 'safety',
    },
    OSHA_ADD: {
        RESOURCE_ID: 'osha300Add',
    },
    OSHA_ESTABLISHMENTS_ADD: {
        RESOURCE_ID: 'establishmentAdd',
    },
    OSHA_ESTABLISHMENTS_LIST: {
        RESOURCE_ID: 'establishmentList',
        SECTION_NAME: 'Osha Establishment',
    },
    OSHA_LIST: {
        PARENT_ID: 'osha',
        SECTION_NAME: 'Osha',
        RESOURCE_ID: 'osha300List',
    },
    EXPERT: {
        RESOURCE_ID: 'safetyExpert',
    },
    CONTENT_LIBRARY: {
        RESOURCE_ID: 'safetyContentLibrary',
    },
};

export default SAFETY;
